// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__TdOAV","empty":"ModalGraph_empty__19DSj"};